import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';

export default function AdminPage() {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // 검색어 상태
  const [cookies, , removeCookie] = useCookies(['uuid']);

  const readUuidFromDocumentCookie = () => {
    const match = document.cookie.match(/(?:^|;\s*)uuid=([^;]*)/);
    return match ? decodeURIComponent(match[1].trim()) : '';
  };

  // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
  const[id,setID] = useState('');
  const[pw,setPW] = useState('');
  const[admin_possible,setAD_PS] = useState('');

  // const[margin,setMargin] = useState('');

  useEffect(() => {
    const uuid = cookies.uuid || readUuidFromDocumentCookie();
    if (!uuid) {
      alert('로그인 정보가 존재하지 않습니다. 관리자 로그인 페이지로 이동합니다.');
      window.location.href = `/AdminLogin`;
      return;
    }
    fetchUserInfo(uuid);
  }, []);

  useEffect(() => {
  }, [cookies.uuid]);

  const fetchUserInfo = (uuid) => {
    const encodedUuid = encodeURIComponent(uuid);
    fetch(`/SetPage/admin_user_binance?uuid=${encodedUuid}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('서버 응답 실패');
        }
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data) || data.length === 0 || !data[0]) {
          throw new Error('세션이 만료되었거나 관리자 정보를 찾을 수 없습니다.');
        }
        const user = data[0];
        setID(user.id);
        setPW(user.pw);
        setAD_PS(user.admin_possible);
      })
      .catch(() => {
        try {
          removeCookie('uuid', { path: '/' });
        } catch {
          document.cookie = 'uuid=; path=/; max-age=0';
        }
        alert('로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.');
        window.location.href = `/AdminLogin`;
      });
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`/admin/users_binance`);
        if (!response.ok) {
          throw new Error('서버 응답 실패');
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error('Waiting List 가져오기 오류:', error);
        alert(error);
      }
    };
  
    fetchUsers();

  }, []);

  // useEffect(() => {
  //   // 서버에서 margin 값을 가져오는 함수
  //   const fetchMargin = async () => {
  //     try {
  //       const response = await fetch('/admin/margin');
  //       if (!response.ok) {
  //         throw new Error('서버 응답 실패');
  //       }
  //       const data = await response.json();
  //       if (data.length > 0) {
  //         setMargin(data[0].magin); // 첫 번째 데이터의 magin 값을 사용
  //       }
  //     } catch (error) {
  //       console.error('margin 값 가져오기 오류:', error);
  //       alert('데이터를 가져오는 데 문제가 발생했습니다.');
  //     }
  //   };

  //   // 컴포넌트가 마운트될 때 호출
  //   fetchMargin();
  // }, []);


    // 사용자 상태값 변경 시마다 useEffect 호출
  useEffect(() => {
    // 상태값이 변경될 때 필요한 작업 수행
    console.log('Users 상태값이 변경되었습니다:');
  }, [users]);


  const handleApprove = async (uid, nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님을 사용승인 처리하시겠습니까?`);

    if (confirmed) {
        try {
          const response = await fetch('/admin/approve_binance', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ uid }),
          });
          if (!response.ok) {
            throw new Error('Failed to approve user');
          }
          const data = await response.json();
          // 해당 사용자의 정보만을 업데이트합니다.
          setUsers(prevUsers => prevUsers.map(user => {
            if (user.uid === uid) {
              return { ...user, login_possible: data[0].login_possible };
            }
            return user;
          }));
            alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 사용승인이 완료 되었습니다.`);
            // 로그인 가능한 경우에 필요한 작업 수행
         } catch (error) {
          console.error('Error approving user:', error);
        }
      };
  };

  const handleRevoke = async (uid,nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님을 사용해제 처리하시겠습니까?`);

    if (confirmed) {
      try {
        const response = await fetch('/admin/revoke_binance', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ uid }),
        });
        if (!response.ok) {
          throw new Error('Failed to revoke user');
        }

        const data = await response.json();
        // 해당 사용자의 정보만을 업데이트합니다.
        if (data.login_possible === 'revoke') {
          setUsers(prevUsers => prevUsers.filter(user => user.uid !== uid));
        } 
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 사용 해제가 완료 되었습니다.`);
          return users;
        } catch (error) {
        console.error('Error revoking user:', error);
      }
    };
  };

  ////////////////// circle 승인여부 //////////////////
  const handle_CIRCLE_Approve = async (uid, nickname) => {
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle version 프로그램 사용 승인하시겠습니까?`);
  
      if (confirmed) {
          try {
            const response = await fetch('/admin/approve_circle_binance', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ uid }),
            });
            if (!response.ok) {
              throw new Error('Failed to approve circle_binance_program');
            }
            const data = await response.json();
            // 해당 사용자의 정보만을 업데이트합니다.
            setUsers(prevUsers => prevUsers.map(user => {
              if (user.uid === uid) {
                return { ...user, circle_possible: data[0].circle_possible };
              }
              return user;
            }));
              alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle version 프로그램 사용승인이 완료 되었습니다.`);
              // 로그인 가능한 경우에 필요한 작업 수행
           } catch (error) {
            console.error('Error approving user:', error);
          }
        };
    };

  const handle_CIRCLE_Revoke = async (uid,nickname) => {
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 circle version 프로그램 사용 해제하시겠습니까?`);
  
      if (confirmed) {
        try {
          const response = await fetch('/admin/revoke_circle_binance', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ uid }),
          });
          if (!response.ok) {
            throw new Error('Failed to revoke user');
          }
  
          const data = await response.json();
          // 해당 사용자의 정보만을 업데이트합니다.
          setUsers(prevUsers => prevUsers.map(user => {
            if (user.uid === uid) {
              return { ...user, circle_possible: data[0].circle_possible };
            }
            return user;
          }));
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 circle version 프로그 사용 해제가 완료 되었습니다.`);
          } catch (error) {
          console.error('Error revoking user:', error);
        }
      };
    };

  ////////////////// circle PRO 승인여부 //////////////////
  const handle_CIRCLEPLUS_Approve = async (uid, nickname) => {
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle PRO version 프로그램 사용 승인하시겠습니까?`);
  
      if (confirmed) {
          try {
            const response = await fetch('/admin/approve_cplus_binance', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ uid }),
            });
            if (!response.ok) {
              throw new Error('Failed to approve cplus_program');
            }
            const data = await response.json();
            // 해당 사용자의 정보만을 업데이트합니다.
            setUsers(prevUsers => prevUsers.map(user => {
              if (user.uid === uid) {
                return { ...user, cplus_possible: data[0].cplus_possible };
              }
              return user;
            }));
              alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle Plus version 프로그램 사용승인이 완료 되었습니다.`);
              // 로그인 가능한 경우에 필요한 작업 수행
           } catch (error) {
            console.error('Error approving user:', error);
          }
        };
    };

  const handle_CIRCLEPLUS_Revoke = async (uid,nickname) => {
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 circle Plus version 프로그램 사용 해제하시겠습니까?`);
  
      if (confirmed) {
        try {
          const response = await fetch('/admin/revoke_cplus_binance', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ uid }),
          });
          if (!response.ok) {
            throw new Error('Failed to revoke user');
          }
  
          const data = await response.json();
          // 해당 사용자의 정보만을 업데이트합니다.
          setUsers(prevUsers => prevUsers.map(user => {
            if (user.uid === uid) {
              return { ...user, cplus_possible: data[0].cplus_possible };
            }
            return user;
          }));
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 circle Plus version 프로그 사용 해제가 완료 되었습니다.`);
          } catch (error) {
          console.error('Error revoking user:', error);
        }
      };
    };

  ////////////////// csupreme version 승인여부 //////////////////
  const handle_CSUPREME_Approve = async (uid, nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle PRO version 프로그램 사용 승인하시겠습니까?`);

    if (confirmed) {
        try {
          const response = await fetch('/admin/approve_csupreme_binance', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ uid }),
          });
          if (!response.ok) {
            throw new Error('Failed to approve csupreme_program');
          }
          const data = await response.json();
          // 해당 사용자의 정보만을 업데이트합니다.
          setUsers(prevUsers => prevUsers.map(user => {
            if (user.uid === uid) {
              return { ...user, csupreme_possible: data[0].csupreme_possible };
            }
            return user;
          }));
            alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle PRO version 프로그램 사용승인이 완료 되었습니다.`);
            // 로그인 가능한 경우에 필요한 작업 수행
         } catch (error) {
          console.error('Error approving user:', error);
        }
      };
  };

  const handle_CSUPREME_Revoke = async (uid,nickname) => {
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle PRO version 프로그램 사용 해제하시겠습니까?`);

    if (confirmed) {
      try {
        const response = await fetch('/admin/revoke_csupreme_binance', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ uid }),
        });
        if (!response.ok) {
          throw new Error('Failed to revoke user');
        }

        const data = await response.json();
        // 해당 사용자의 정보만을 업데이트합니다.
        setUsers(prevUsers => prevUsers.map(user => {
          if (user.uid === uid) {
            return { ...user, csupreme_possible: data[0].csupreme_possible };
          }
          return user;
        }));
        alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 Circle PRO version 프로그 사용 해제가 완료 되었습니다.`);
        } catch (error) {
        console.error('Error revoking user:', error);
      }
    };
  };

    ////////////////// 이메일 변경 ////////////////////
  const handleChangeEmail = async (uid, nickname) => {
      const newEmail = window.prompt(`UID : ${uid} / NICKNAME : ${nickname} 님의 새 이메일을 입력하세요:`);
    
      if (!newEmail) return; // 사용자가 취소를 누르면 아무 작업도 하지 않음
    
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 e-mail을 "${newEmail}"(으)로 변경하시겠습니까?`);
    
      if (confirmed) {
        try {
          const response = await fetch('/admin/change_email_binance', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid, email: newEmail }), // 새 이메일 전송
          });
    
          if (!response.ok) throw new Error('Failed to change email');
    
          const data = await response.json();
    
          setUsers(prevUsers => prevUsers.map(user => 
            user.uid === uid ? { ...user, email: data[0].email } : user
          ));
    
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 e-mail 정보가 변경 완료 되었습니다.`);
        } catch (error) {
          console.error('Error changing email:', error);
        }
      }
    };
    
    ////////////////// 비밀번호 변경 ////////////////////
  const handleChangePassword = async (uid, nickname) => {
      const newPassword = window.prompt(`UID : ${uid} / NICKNAME : ${nickname} 님의 새 비밀번호를 입력하세요:`);
    
      if (!newPassword) return; // 사용자가 취소를 누르면 아무 작업도 하지 않음
    
      const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 비밀번호를 "${newPassword}"(으)로 변경하시겠습니까?`);
    
      if (confirmed) {
        try {
          const response = await fetch('/admin/change_password_binance', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid, pw: newPassword }), // 새 이메일 전송
          });
    
          if (!response.ok) throw new Error('Failed to change password');
    
          const data = await response.json();
    
          setUsers(prevUsers => prevUsers.map(user => 
            user.uid === uid ? { ...user, pw: data[0].pw } : user
          ));
    
          alert(`UID : ${uid} / NICKNAME : ${nickname} 님의 password 정보가 변경 완료 되었습니다.`);
        } catch (error) {
          console.error('Error changing email:', error);
        }
      }
    };
  
  ////////////////// 닉네임 변경 ////////////////////
  const handleChangeNickname = async (uid, nickname) => {
    const newNickname = window.prompt(`UID : ${uid} / NICKNAME : ${nickname} 님의 새 닉네임을 입력하세요:`);
  
    if (!newNickname) return; // 사용자가 취소를 누르면 아무 작업도 하지 않음
  
    const confirmed = window.confirm(`UID : ${uid} / NICKNAME : ${nickname} 님의 닉네임을 "${newNickname}"(으)로 변경하시겠습니까?`);
  
    if (confirmed) {
      try {
        const response = await fetch('/admin/change_nickname_binance', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ uid, nickname: newNickname }), // 새 Nickname 전송
        });
  
        if (!response.ok) throw new Error('Failed to change nickname');
  
        const data = await response.json();
  
        setUsers(prevUsers => prevUsers.map(user => 
          user.uid === uid ? { ...user, nickname: data[0].nickname } : user
        ));
  
        alert(`UID : ${uid} 님의 NICKNAME 정보가 변경 완료 되었습니다.`);
      } catch (error) {
        console.error('Error changing nickname:', error);
      }
    }
  };


  // 승인 및 슈퍼승인 여부에 따른 스타일을 정의하는 함수
const getApprovalStyle = (loginPossible) => ({
  color: loginPossible === "1" || loginPossible === 1 ? "#22c55e" : "#f97316",
  fontWeight: 600,
});

// 승인 및 슈퍼승인 여부에 따른 텍스트를 생성하는 함수
const getApprovalText = (user) => {
  const base =
    user.login_possible === "1" || user.login_possible === 1
      ? "승인"
      : "승인대기중";

  const grantedTags = featureConfigs
    .filter(
      ({ possibleKey }) =>
        user[possibleKey] === "1" || user[possibleKey] === 1
    )
    .map(({ tag }) => tag);

  return grantedTags.length ? `${base} / ${grantedTags.join(" / ")}` : base;
};


//로그아웃
const handleLogout = () => {
  const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
  if (!uuid) {
    alert('로그인 정보가 존재하지 않습니다.');
    return;
  }
  // 로그아웃 요청을 서버로 보냅니다.
  fetch('/super_logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ userId: uuid })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('로그아웃 요청 실패');
    }
    console.log('로그아웃 성공');
    alert('Logout is successful.');
    window.location.href = '/adminlogin';
  })
  .catch(error => {
    console.error('로그아웃 요청 중 오류 발생:', error);
  });
// UUID를 서버로 보내는 예시 코드

}

// 셋팅페이지로 이동
const handleMoveBitget = () => {
  const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
  if (!uuid) {
    alert('로그인 정보가 존재하지 않습니다.');
    return;
  }
  console.log('셋팅페이지로 이동');
  window.location.href = '/Adminpage';
}

// 검색어가 포함된 사용자만 필터링
const filteredUsers = users.filter(
  (user) =>
    user.uid.toString().includes(searchQuery) ||
    user.nickname.toLowerCase().includes(searchQuery.toLowerCase())
);

const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
};

const featureConfigs = [
  {
    key: "circle",
    label: "Circle",
    tag: "CC",
    possibleKey: "circle_possible",
    approveHandler: (uid, nickname) => handle_CIRCLE_Approve(uid, nickname),
    revokeHandler: (uid, nickname) => handle_CIRCLE_Revoke(uid, nickname),
  },
  {
    key: "circlepro",
    label: "Circle PRO",
    tag: "CP",
    possibleKey: "csupreme_possible",
    approveHandler: (uid, nickname) => handle_CSUPREME_Approve(uid, nickname),
    revokeHandler: (uid, nickname) => handle_CSUPREME_Revoke(uid, nickname),
  },
  {
    key: "circleplus",
    label: "Circle Plus",
    tag: "CS",
    possibleKey: "cplus_possible",
    approveHandler: (uid, nickname) => handle_CIRCLEPLUS_Approve(uid, nickname),
    revokeHandler: (uid, nickname) => handle_CIRCLEPLUS_Revoke(uid, nickname),
  }
];

  const isReadOnly = admin_possible === "1" || admin_possible === 1;
  const orderedUsers = filteredUsers.slice().reverse();

  return (
    // <main className="admin-dashboard">
    <main className="kp-console kp-console--binance">
      <div className="admin-dashboard__glare" aria-hidden="true" />
      <section className="admin-dashboard__panel">
        <header className="admin-dashboard__hero">
          <div>
            <p className="admin-dashboard__eyebrow">Binance control center</p>
            <h1 className="admin-dashboard__title">Super admin console</h1>
          </div>
          <div className="admin-dashboard__hero-actions">
            <button
              type="button"
              className="admin-dashboard__btn admin-dashboard__btn--ghost"
              onClick={handleMoveBitget}
            >
              Bitget 관리자
            </button>
            <button
              type="button"
              className="admin-dashboard__btn admin-dashboard__btn--danger"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </header>

        <div className="admin-dashboard__controls">
          <div className="admin-dashboard__search">
            <input
              type="text"
              placeholder="UID 또는 닉네임으로 검색"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <span>{orderedUsers.length} users</span>
          </div>
        </div>

        <div className="admin-dashboard__table-wrapper">
          <table className="admin-dashboard__table">
            <thead>
              <tr>
                <th>#</th>
                <th>UID</th>
                <th>Nickname</th>
                <th>승인 상태</th>
                <th>계정</th>
                {featureConfigs.map((feature) => (
                  <th key={feature.key}>{feature.label} 승인</th>
                ))}
                <th>정보 변경</th>
              </tr>
            </thead>
            <tbody>
              {orderedUsers.length === 0 && (
                <tr>
                  <td colSpan={6 + featureConfigs.length}>
                    <div className="admin-dashboard__empty">
                      검색 결과가 없습니다.
                    </div>
                  </td>
                </tr>
              )}
              {orderedUsers.map((user, index) => (
                <tr key={user.uid}>
                  <td>{index + 1}</td>
                  <td>{user.uid}</td>
                  <td>{user.nickname}</td>
                  <td style={getApprovalStyle(user.login_possible)}>
                    {getApprovalText(user)}
                  </td>
                  <td>
                    <div className="admin-dashboard__button-group">
                      <button
                        type="button"
                        className="admin-dashboard__button admin-dashboard__button--approve"
                        onClick={() => handleApprove(user.uid, user.nickname)}
                      >
                        승인
                      </button>
                      <button
                        type="button"
                        className="admin-dashboard__button admin-dashboard__button--delete"
                        disabled={isReadOnly}
                        onClick={() => handleRevoke(user.uid, user.nickname)}
                      >
                        삭제
                      </button>
                    </div>
                  </td>
                  {featureConfigs.map((feature) => (
                    <td key={`${user.uid}-${feature.key}`}>
                      <div className="admin-dashboard__button-group">
                        <button
                          type="button"
                          className="admin-dashboard__button admin-dashboard__button--approve"
                          disabled={isReadOnly}
                          onClick={() =>
                            feature.approveHandler(user.uid, user.nickname)
                          }
                        >
                          승인
                        </button>
                        <button
                          type="button"
                          className="admin-dashboard__button admin-dashboard__button--revoke"
                          disabled={isReadOnly}
                          onClick={() =>
                            feature.revokeHandler(user.uid, user.nickname)
                          }
                        >
                          해제
                        </button>
                      </div>
                    </td>
                  ))}
                  <td>
                    <div className="admin-dashboard__button-group admin-dashboard__button-group--stacked">
                      <button
                        type="button"
                        className="admin-dashboard__button admin-dashboard__button--ghost"
                        disabled={isReadOnly}
                        onClick={() => handleChangeEmail(user.uid, user.nickname)}
                      >
                        이메일
                      </button>
                      <button
                        type="button"
                        className="admin-dashboard__button admin-dashboard__button--ghost"
                        disabled={isReadOnly}
                        onClick={() =>
                          handleChangePassword(user.uid, user.nickname)
                        }
                      >
                        비밀번호
                      </button>
                      <button
                        type="button"
                        className="admin-dashboard__button admin-dashboard__button--ghost"
                        disabled={isReadOnly}
                        onClick={() =>
                          handleChangeNickname(user.uid, user.nickname)
                        }
                      >
                        닉네임
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
};